import type { ReactNode } from "react";

interface AuthCardProps {
  title: string;
  subtitle: string;
  children: ReactNode;
  footer?: ReactNode;
}

export function AuthCard({ title, subtitle, children, footer }: AuthCardProps) {
  return (
    <div className="ev-login">
      <style>{AUTH_CSS}</style>
      <div className="ev-login__card">
        <div className="ev-login__brand">
          <span className="ev-login__mark">EV</span>
          <h1>{title}</h1>
          <p>{subtitle}</p>
        </div>
        {children}
        {footer && <div className="ev-login__hint">{footer}</div>}
      </div>
    </div>
  );
}

export const AUTH_CSS = `
.ev-login {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 24px;
  background: #f3f5f4;
}
.ev-login__card {
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border: 1px solid #e2e7e5;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 12px 40px rgba(23, 32, 30, 0.08);
}
.ev-login__brand {
  text-align: center;
  margin-bottom: 28px;
}
.ev-login__mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background: #17201e;
  color: #ff7a00;
  font-weight: 800;
  font-size: 18px;
  margin-bottom: 16px;
}
.ev-login__brand h1 {
  font-size: 22px;
  font-weight: 700;
  color: #17201e;
  margin: 0 0 6px;
}
.ev-login__brand p {
  color: #6e7b78;
  margin: 0;
}
.ev-login__form {
  display: grid;
  gap: 16px;
}
.ev-login__field {
  display: grid;
  gap: 6px;
}
.ev-login__field span {
  font-size: 13px;
  font-weight: 600;
  color: #17201e;
}
.ev-login__field input, .ev-login__field textarea {
  padding: 12px 14px;
  border: 1px solid #e2e7e5;
  border-radius: 10px;
  font-size: 15px;
  color: #17201e;
  background: #ffffff;
  outline: none;
  resize: vertical;
}
.ev-login__field input:focus, .ev-login__field textarea:focus {
  border-color: #ff7a00;
  box-shadow: 0 0 0 3px rgba(255, 122, 0, 0.12);
}
.ev-login__error {
  padding: 12px 14px;
  border-radius: 8px;
  background: #fff0ef;
  color: #c94444;
  font-size: 13px;
}
.ev-login__success {
  padding: 12px 14px;
  border-radius: 8px;
  background: #e8f7f2;
  color: #147a5f;
  font-size: 13px;
}
.ev-login__submit {
  padding: 14px;
  border: none;
  border-radius: 10px;
  background: #ff7a00;
  color: #ffffff;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.ev-login__submit:hover:not(:disabled) {
  background: #d95e08;
}
.ev-login__submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.ev-login__hint {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e2e7e5;
  font-size: 12px;
  color: #6e7b78;
  text-align: center;
}
.ev-login__hint a, .ev-login__hint button {
  color: #ff7a00;
  text-decoration: none;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
}
.ev-login__hint a:hover, .ev-login__hint button:hover {
  text-decoration: underline;
}
.ev-login__submit--secondary {
  background: #17201e;
}
.ev-login__submit--secondary:hover:not(:disabled) {
  background: #2d3b38;
}
.ev-login__secondary {
  padding: 12px;
  border: 1px solid #e2e7e5;
  border-radius: 10px;
  background: #ffffff;
  color: #17201e;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.ev-login__secondary:hover:not(:disabled) {
  background: #f3f5f4;
  border-color: #c9d2cf;
}
.ev-login__secondary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
`;
